/**
 * Search - Expandable Filters
 * =================================
 *
 * Toggle visibility of control list items.
 *
 */

import $ from 'qwery';

const countHideableItems = (context) => $('.is-hideable', context).length;
const isListExpanded = (list) => list.classList.contains('is-expanded');

function updateExpandText (context) {
    const expandTextEl = $('.controlList-text--expand', context)[0];

    if (expandTextEl) {
        const hideableCount = countHideableItems(context);
        const linkCount = $('span', expandTextEl)[0];

        if (linkCount) {
            linkCount.textContent = hideableCount;
        }
    }
}

function expandList (list) {
    list.classList.add('is-expanded');
    $('.controlList-item.is-hideable', list).forEach(item => { item.classList.add('is-shown'); });
    $('.controlList-text--expand', list)[0].classList.add('is-hidden');
    $('.controlList-text--collapse', list)[0].classList.remove('is-hidden');
}

function collapseList (list) {
    list.classList.remove('is-expanded');
    $('.controlList-item.is-hideable', list).forEach(item => { item.classList.remove('is-shown'); });
    $('.controlList-text--expand', list)[0].classList.remove('is-hidden');
    $('.controlList-text--collapse', list)[0].classList.add('is-hidden');
}

(function init () {
    $('[data-expandable]').forEach(list => {
        const expandLink = $('[data-toggle-expand]', list)[0];

        if (expandLink) {
            expandLink.addEventListener('click', e => {
                e.preventDefault();

                if (list.classList.contains('is-expanded')) {
                    collapseList(list);
                } else {
                    expandList(list);
                }
            });
        }
    });
}());

export {
    isListExpanded,
    updateExpandText,
    collapseList
};
